import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

export class ObavijestiCasino extends React.Component {

    constructor(props) {
        super(props);
        this.state = { pravilaOznacena: false, pravilaJednomOznacena: false }


        this.const_CasinoStart = "CasinoStart"

        this.sakrijObavijest = this.sakrijObavijest.bind(this);
        this.togglePravila = this.togglePravila.bind(this);

    }


    sakrijObavijest(naziv) {
        if (this.state.pravilaOznacena) {
            this.props.sakrijObavijestFn(naziv);
        }
    }

    togglePravila() {
        var pravilaSelected = !this.state.pravilaOznacena;
        this.setState({
            pravilaOznacena: pravilaSelected,
            pravilaJednomOznacena: true
        });
    }
    render() {
        if (this.props.userChecked && this.props.user && this.props.user.obavijesti.indexOf(this.const_CasinoStart) != -1)
            return <div className="overlay" style={{ fontSize: '.9rem' }}>
                <div className="overlay--content">
                    <div style={{ maxWidth: '600px' }}>
                        <div className="margin-bottom-small">
                            <span className=" text-xbold" style={{ textAlign: 'center', display: 'block', fontSize: '2.1rem' }}>
                                Dobrodošli u Casino
                            </span>
                        </div>
                        <div className="margin-bottom-small">
                            <span className="" style={{ textAlign: 'center', display: 'block', fontSize: '1.5rem', fontWeight: 600 }} >
                                Zavrti sreću i neka zabava počne uz pregršt casino igara.
                            </span>
                        </div>
                        {/* <div className="margin-bottom">
                            <span className="">
                                <span className="text-bold text-red">Novost</span> u vašem Računu je <span className="text-bold">prijenos novca</span> iz Glavnog računa u Casino račun bez naknade.
                            </span>
                        </div> */}
                        <div className="margin-bottom">
                            <hr />
                        </div>

                        <div className="margin-bottom">
                            <span className="" >
                                <button className="link padding-nula" onClick={this.togglePravila}><span className={'icon ' + (this.state.pravilaOznacena ? 'ico-check-on  text-dark-blue' : 'ico-check-off text-gray')}></span></button>&nbsp;
                                Razumijem i prihvaćam <b><a href={casino.config.urls.pravilaIgre} className="link blue"><span>Pravila</span></a></b> i <b><a href={casino.config.urls.zastitaPrivatnosti} className="link blue"><span>Opće odredbe o zaštiti osobnih podataka</span></a></b>.
                            </span>
                        </div>

                        <div style={{ width: '108%', marginLeft: '-4%', textAlign: "center", maxWidth: '600px' }}>
                            <img src="content/images/assets/img_dialog_promo_first_deposit_50fs.png" style={{ width: '100%', maxWidth: '400px' }}>
                            </img>
                        </div>


                        <div className="margin-bottom-small" style={{ marginTop: '-1rem' }}>
                            <span className="" style={{ textAlign: 'center', display: 'block' }} >

                                <b>Prenesi sredstva</b> s Glavnog na Casino & Poker račun i odaberi <b>"želim bonus".</b>

                            </span>
                            <span style={{ color: '#c50d2f', lineHeight: '3rem', display: 'block', textAlign: 'center' }}><b>
                                Preneseni iznos bit će udvostručen.
                                </b>                       </span>

                        </div>

                        <div className="" style={{ textAlign: 'center', marginTop: '1.5rem', marginBottom: '1rem' }}>
                            {this.state.pravilaOznacena ?
                                <NavLink onClick={() => this.sakrijObavijest(this.const_CasinoStart)} to="/account"
                                    className={"red btn medium fill btn"}><span>Prenesi novac sada</span></NavLink>
                                :
                                <NavLink to="/"
                                    className={"red btn medium fill btn disabled"}><span>Prenesi novac sada</span></NavLink>
                            }


                        </div>



                    </div>
                </div>
            </div>


        return null;
    }

    // render() {
    //     if (this.props.userChecked && this.props.user && this.props.user.obavijesti.indexOf(this.const_CasinoStart) != -1)
    //         return (
    //             <div className="overlay" style={{fontSize: '1rem'}}>
    //                 <div className="overlay--content">
    //                     <div className="margin-bottom">
    //                         <span className="text-xlarge text-xbold">
    //                             Dobrodošli u Casino
    //                         </span>
    //                     </div>
    //                     <div className="margin-bottom">
    //                         <span className="">
    //                             Zavrti sreću i neka zabava počne uz pregršt novih i classic casino igara.
    //                         </span>
    //                     </div>
    //                     <div className="margin-bottom">
    //                         <span className="">
    //                             <span className="text-bold text-red">Novost</span> u vašem Računu je <span className="text-bold">prijenos novca</span> iz Glavnog računa u Casino račun bez naknade.
    //                         </span>
    //                     </div>
    //                     <div className="margin-bottom ">
    //                         <hr />
    //                     </div>

    //                     <div className="margin-bottom">
    //                         <span className="">
    //                             <button className="link padding-nula" onClick={this.togglePravila}><span className={'icon ' + (this.state.pravilaOznacena ? 'ico-check-on  text-dark-blue' : 'ico-check-off text-gray')}></span></button>&nbsp;
    //                             Razumijem i prihvaćam <a href={casino.config.urls.pravilaIgre} className="link blue"><span>Pravila</span></a> i <a href={casino.config.urls.zastitaPrivatnosti} className="link blue"><span>Opće odredbe o zaštiti osobnih podataka</span></a>.
    //                         </span>
    //                     </div>
    //                     <div className={this.state.pravilaJednomOznacena ? '' : 'hidden'}>
    //                         <div className="margin-bottom ">
    //                             <hr />
    //                         </div>

    //                         <div className="margin-bottom-small">
    //                             <span className="">
    //                                 Trenutni saldo Casino računa iznosi: <span className="text-bold">{this.props.user && casino.utils.numberToKune(this.props.user.casinoRaspolozivo)}.</span>
    //                             </span>
    //                         </div>
    //                         <div className="margin-bottom">
    //                             <ReactRouterDOM.NavLink onClick={() => this.sakrijObavijest(this.const_CasinoStart)} to="/account/wallet" className="link blue"><span>Prenesi novac u Casino</span></ReactRouterDOM.NavLink>
    //                         </div>
    //                         <br />
    //                         <div className="margin-bottom">
    //                             <button disabled={!this.state.pravilaOznacena} onClick={() => this.sakrijObavijest(this.const_CasinoStart)} className="link blue padding-nula"><span className="text-bold">U REDU</span></button>
    //                         </div>

    //                     </div>
    //                     <br />
    //                 </div>
    //             </div>
    //         )

    //     return null;
    // }
};
